/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateManualPalletData } from '../../models/create-manual-pallet-data';

export interface GetManualContainerCreationData$Params {
  productionOrderId: number;
}

export function getManualContainerCreationData(http: HttpClient, rootUrl: string, params: GetManualContainerCreationData$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateManualPalletData>> {
  const rb = new RequestBuilder(rootUrl, getManualContainerCreationData.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateManualPalletData>;
    })
  );
}

getManualContainerCreationData.PATH = '/api/v1/Containers/{productionOrderId}/GetManualContainerCreationData';
